import styled, { css } from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #949494;
    border-radius: 4px;
  }
`;
export const HeaderConfiguration = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 3px;

  span {
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: center;
    margin-top: -1px;
    color: #ffffff;
  }

  /* div {
        display: flex;
        justify-content: start;
        align-items: center;
        
    } */
`;

export const ButtonFilterContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonFilterHeader = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  ${(props) =>
    props.checking &&
    css`
      border-bottom: 3px solid #ffffff;
    `}
`;

export const SearchContainer = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #a7a7a7;

  input {
    width: 100%;
    height: 30px;
    outline: none;
    border: none;
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #4d4d4d;
  }
`;
export const FilterContainer = styled.div``;

export const FilterContent = styled.div`
  position: absolute;
  display: ${(props) => (props.open ? "flex" : "none")};
  flex-direction: column;
  justify-content: space-between;
  width: 205px;
  height: 124px;
  box-sizing: border-box;
  padding: 10px;
  z-index: 9999;
  right: 0px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  border-radius: 2px;

  span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #4d4d4d;
    cursor: pointer;
  }
`;
export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
`;
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  height: 59px;
  border-bottom: 1px solid #a7a7a7;
  z-index: 1;
`;
export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 57px;
  min-height: 57px;
  margin-left: 5px;
  border-radius: 50%;
  background: #c4c4c4;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;

  img {
    width: 57px;
    height: 57px;
  }
`;

export const Status = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${(props) => props.colorBackground};
  margin-right: 10px;
`;
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 150px;
  height: 60px;
  margin-left: 10px;

  div {
    display: flex;
    justify-content: start;
    align-items: center;
  }
`;
export const UserName = styled.span`
  display: flex;
  align-items: center;
  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #4d4d4d;
`;
export const UserDate = styled.span`
  display: flex;
  align-items: center;
  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 15px;
  color: #959595;
`;
export const DurationCall = styled.span`
  align-items: center;
  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 15px;
  color: #959595;
`;

export const Buttons = styled.div`
  padding: 15px;
`;
